module.exports = __webpack_public_path__ + "img/phil-website-min.e3e8c975.jpg";